import React, { useState } from 'react';
import { motion } from 'framer-motion';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import { Card, CardContent } from '../components/ui/card';
import { COMPANY_INFO } from '../config/assets';
import { Youtube, Play } from 'lucide-react';

const VideosPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.35 }
  };

  // Featured videos (you can expand this list)
  const featuredVideos = [
    {
      id: 'hPxEF7U1qV0',
      title: 'Residential Polished Concrete Showcase',
      description: 'Premium residential installation with stunning results'
    },
    {
      id: 'vWCSHP4UB_Q',
      title: 'Canva Headquarters',
      description: 'Large-scale commercial concrete polishing'
    },
    {
      id: 'BcSCGXrC2u4',
      title: 'Doltone House Reception',
      description: 'Commercial reception venue video'
    },
    {
      id: 'nz0AmwAw4Ko',
      title: 'Project Showcase',
      description: 'Professional polished concrete installation'
    },
    {
      id: 'SDKO97wf-8U',
      title: 'Commercial Space Transformation',
      description: 'Before and after commercial project'
    },
    {
      id: 'N53248vBABc',
      title: 'Residential Project Details',
      description: 'Detailed residential installation process'
    },
    {
      id: 'bXYB4-kEhfA',
      title: 'Basement Polishing Project',
      description: 'Residential basement transformation showcase'
    },
    {
      id: 'Xz-PZdWdRWE',
      title: 'Award Winning Home Project',
      description: 'Premium residential polished concrete installation'
    },
    {
      id: 'jG7W8HbQZ_Q',
      title: 'Bodyfit Gym Project',
      description: 'Commercial fitness facility polished concrete'
    }
  ];

  return (
    <div className="min-h-screen pt-16" data-testid="videos-page">
      {/* Hero with YouTube Branding */}
      <section className="relative section-spacing bg-gradient-to-br from-red-50 via-white to-red-50 dark:from-red-950 dark:via-slate-900 dark:to-red-950 overflow-hidden">
        {/* Decorative YouTube Logo Background */}
        <div className="absolute top-10 right-10 opacity-5">
          <Youtube className="h-64 w-64 text-red-500" />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <motion.div {...fadeInUp}>
            <div className="flex items-center justify-center mb-6">
              <div className="bg-red-600 rounded-2xl p-4 mr-4 shadow-lg">
                <Youtube className="h-12 w-12 text-white" />
              </div>
              <div className="text-left">
                <h1 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent">
                  Video Gallery
                </h1>
                <p className="text-red-600 font-medium">Powered by YouTube</p>
              </div>
            </div>
            <p className="text-lg text-slate-600 dark:text-slate-300 max-w-3xl mx-auto mb-8">
              Watch our concrete polishing projects, tutorials, and behind-the-scenes content. 
              Get expert tips and see our craftsmanship in action.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Simple Video Grid Test */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8 text-slate-800 dark:text-slate-100">
            Our Featured Videos
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {featuredVideos.map((video, index) => (
              <div key={video.id} className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-4">
                <div className="aspect-video bg-slate-200 dark:bg-slate-700 rounded-lg mb-4 flex items-center justify-center">
                  <img 
                    src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                    alt={video.title}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                <h3 className="font-bold text-lg mb-2 text-slate-800 dark:text-slate-100">
                  {video.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-300 text-sm">
                  {video.description}
                </p>
                <button 
                  onClick={() => window.open(`https://www.youtube.com/watch?v=${video.id}`, '_blank')}
                  className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                >
                  Watch Video
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default VideosPage;
